import { eventItems, moreEventItems } from '@/data';
import type { DynamicEventData, EventDetail } from '@/types';

// id can be a numeric event ID (regular events) or a 96-character eventcode string (closed events)
export async function fetchDynamicEvent(id: number | string): Promise<DynamicEventData> {
  const params = new URLSearchParams({
    id: id.toString()
  });
  let urlParams = '';
  
  urlParams = '?' + params.toString();

  try {
    const response = await fetch('/of2/json/event_dynamic_data'+urlParams, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });
    const data = await response.json();
    if (data) {
        console.log("Fetched dynamic event data:", data);
      return data;
    } else {
      throw new Error('Invalid event format');
    }
  } 
  catch (e) {
    console.error("Failed to fetch dynamic event:", e);






    // Temporary fallback for frontend testing if backend is broken

    // Use eventItems to get the event with the given ID as a fallback
    // Merge eventItems and moreEvents before finding the event
    const allEvents = [...eventItems, ...moreEventItems];
    const fallbackEvent = allEvents.find(event => event.id === id) as EventDetail;

    if (fallbackEvent) {
      console.warn("Using fallback event from eventItems:", fallbackEvent);
      return {
        remaining_tickets: fallbackEvent.remaining_tickets,
        id: fallbackEvent.id,
        publishtime: randomFutureTimestamp(1, 30),
        publishtime_gmt_offset: 0,
        closed_event: false,
      } as DynamicEventData;
    }
    // Remove this fallback when backend is stable





    return {} as DynamicEventData; // Fallback empty event
  }
}

// TODO delete
const now = Math.floor(Date.now() / 1000);
function randomFutureTimestamp(minDays: number, maxDays: number) {
  const days = Math.floor(Math.random() * (maxDays - minDays + 1)) + minDays;
  return now + days * 86400;
}

